import { ResetPasswordForm, Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useRouter } from '@u'
import { useTranslation } from 'react-i18next'

export const ResetPasswordPage = ({}) => {
  const { t } = useTranslation()
  const router = useRouter()
  return (
    <AuthContent
      title={t('auth.resetPasswordPage.title')}
      extra={
        <p>
          {t('auth.resetPasswordPage.remember_password')}{' '}
          <Link name="login">{t('auth.resetPasswordPage.login_link')}</Link>
        </p>
      }
    >
      <ResetPasswordForm
        onSuccess={() => {
          router.push({ name: 'resetPasswordSuccess' })
        }}
      />
    </AuthContent>
  )
}
